export default __webpack_public_path__ + "static/media/shirt-back.b4fdecc9.png";